(function () {
  // ---------- helpers ----------
  const getRoot = (el) => el.closest('[data-hv-picker]');
  const getIdsToRefresh = (root) =>
    (root?.dataset?.refreshSectionIds || '')
      .split(',').map(s => s.trim()).filter(Boolean);
  const updateUrl = (root) => root?.dataset?.updateUrl !== 'false';
  const samePath = (a, b) => a.replace(/\/+$/, '') === b.replace(/\/+$/, '');

  function selectedIds(root) {
    const ids = [];
    root.querySelectorAll('fieldset').forEach(fs => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) ids.push(checked.dataset.optionValueId);
    });
    root.querySelectorAll('select[data-hv-select]').forEach(sel => {
      const opt = sel.options[sel.selectedIndex];
      if (opt?.dataset?.optionValueId) ids.push(opt.dataset.optionValueId);
    });
    return ids;
  }

  // re-run scripts contained in newly injected HTML
  function runScriptsIn(container) {
    container.querySelectorAll('script:not([src])').forEach(old => {
      const s = document.createElement('script');
      s.type = old.type || 'text/javascript';
      s.textContent = old.textContent;
      old.replaceWith(s);
    });
    container.querySelectorAll('script[src]').forEach(old => {
      const s = document.createElement('script');
      s.type = old.type || 'text/javascript';
      s.src = old.src;
      s.defer = true;
      old.replaceWith(s);
    });
  }

  function replaceSection(sectionId, htmlById) {
    const mount = document.getElementById(sectionId) ||
                  document.querySelector(`#shopify-section-${CSS.escape(sectionId)}`);
    const html = htmlById[sectionId];
    if (!mount || !html) return false;
    mount.innerHTML = html;
    runScriptsIn(mount);
    mount.dispatchEvent(new CustomEvent('section:replaced', { bubbles: true, detail: { sectionId } }));
    return true;
  }

  async function fetchSections(urlString, sectionIds, optionValueIds) {
    const url = new URL(urlString, window.location.origin);
    if (optionValueIds?.length) url.searchParams.set('option_values', optionValueIds.join(','));
    if (sectionIds?.length) url.searchParams.set('sections', sectionIds.join(','));
    const res = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!res.ok) throw new Error('Section fetch failed');
    return res.json(); // { "<sectionId>": "<html>" }
  }

  async function swapToSibling(targetEl, root, optIds) {
    const productUrl = targetEl?.dataset?.productUrl;
    if (!productUrl) return false;

    const current = window.location.pathname.replace(/\/+$/, '');
    if (samePath(productUrl, current)) return false;

    const sectionIds = getIdsToRefresh(root);
    if (!sectionIds.length) {
      // no mounts declared: safest is to navigate
      window.location.assign(`${productUrl}?option_values=${encodeURIComponent(optIds.join(','))}`);
      return true;
    }

    let htmlById;
    try {
      htmlById = await fetchSections(productUrl, sectionIds, optIds);
    } catch {
      window.location.assign(`${productUrl}?option_values=${encodeURIComponent(optIds.join(','))}`);
      return true;
    }

    let replaced = false;
    sectionIds.forEach(id => { if (replaceSection(id, htmlById)) replaced = true; });
    if (!replaced) {
      window.location.assign(`${productUrl}?option_values=${encodeURIComponent(optIds.join(','))}`);
      return true;
    }

    if (updateUrl(root)) {
      const next = new URL(productUrl, window.location.origin);
      if (optIds?.length) next.searchParams.set('option_values', optIds.join(','));
      history.pushState({}, '', next.toString());
    }

    document.dispatchEvent(new CustomEvent('product:switch', {
      bubbles: true,
      detail: { productUrl, optionValueIds: optIds }
    }));

    return true;
  }

  async function refreshSameProduct(root, optIds) {
    const sectionIds = getIdsToRefresh(root);
    if (!sectionIds.length) return;

    const url = new URL(window.location.href);
    url.searchParams.set('option_values', optIds.join(','));
    url.searchParams.set('sections', sectionIds.join(','));
    const res = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!res.ok) return;
    const htmlById = await res.json();
    sectionIds.forEach(id => replaceSection(id, htmlById));
    if (updateUrl(root)) history.replaceState({}, '', url.toString());
  }

  function changedTarget(e) {
    const radio = e.target.closest('input[type="radio"][data-option-value-id]');
    if (radio) return radio;
    if (e.target.matches('select[data-hv-select]')) {
      return e.target.options[e.target.selectedIndex];
    }
    return null;
  }

  // ---------- delegated handler (survives swaps) ----------
  document.addEventListener('change', async (e) => {
    const root = getRoot(e.target);
    if (!root) return;

    const tgt = changedTarget(e);
    if (!tgt) return;

    const ids = selectedIds(root);
    if (!ids.length) return;

    const jumped = await swapToSibling(tgt, root, ids);
    if (!jumped) await refreshSameProduct(root, ids);
  }, true);
})();
